<template>
  <v-container>
    <v-row>
      <v-col cols="6">
        <h2>Bankverbindungen</h2>
      </v-col>
      <v-col cols="6" class="text-right">
        <v-btn
          color="primary"
          :to="{ name: 'kige-bank-account-create' }"
        >
          <v-icon left>mdi-plus</v-icon>
          Neue Bankverbindung
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-text-field
          v-model="search"
          label="Suche"
          clearable
          dense
          outlined
          class="mb-4"
          prepend-inner-icon="mdi-magnify"
        ></v-text-field>
        <v-data-table
          :headers="headers"
          :items="bankAccounts"
          :search="search"
          @click:row="goToDetail"
          class="elevation-1"
          style="cursor: pointer"
        >
          <template #item.active="{ item }">
            <v-icon v-if="item.active" color="green">mdi-check</v-icon>
            <v-icon v-else color="grey">mdi-close</v-icon>
          </template>
          <template #item.ignore_for_processing="{ item }">
            <v-icon v-if="item.ignore_for_processing" color="orange">mdi-alert</v-icon>
            <v-icon v-else color="grey">mdi-minus</v-icon>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { GET_BANK_ACCOUNTS } from '@/modules/kirchgeld/store/kirchgeld/action-types'
import { mapState } from 'vuex'

export default {
  name: 'BankAccountList',
  data () {
    return {
      search: '',
    }
  },
  computed: {
    ...mapState('kirchgeld', ['bankAccounts']),
    headers () {
      return [
        { text: 'Name', value: 'name' },
        { text: 'IBAN', value: 'iban' },
        { text: 'Beschreibung', value: 'description' },
        { text: 'Aktiv', value: 'active' },
        { text: 'Nicht verarbeiten', value: 'ignore_for_processing' },
      ]
    }
  },
  async mounted () {
    await this.$store.dispatch('kirchgeld/' + GET_BANK_ACCOUNTS)
  },
  methods: {
    goToDetail (item) {
      this.$router.push({
        name: 'kige-bank-account-detail',
        params: { 'bank-account-id': item.id }
      })
    }
  }
}
</script>

<style scoped>
</style>
